import {IconicGTMPurchase} from './gtm-purchase.js';

/**
 * Handle post-purchase Impact event.
 */
class IconicImpactPurchase {
	/**
	 * Check is purchase response is a trial.
	 *
	 * @param response
	 * @param title
	 * @returns {boolean}
	 */
	static pushReferral = ( response, title = '' ) => {
		let data = {
			'action': 'iconic_impact_ajax_referral',
			'nonce': iconicVars.nonce,
			'CampaignId': 15459,
			'ActionTrackerId': 29064,
			'OrderId': IconicGTMPurchase.responseGetTransactionId( response ),
			'CustomerId': '',
			'CustomerEmail': '',
			'ItemName1': title,
			'ItemSku1': IconicGTMPurchase.responseGetPluginId( response ) + '-' + IconicGTMPurchase.responseGetPlanId( response ),
			'ItemSubTotal1': IconicGTMPurchase.responseGetTotal( response ),
		};

		jQuery.post( iconicVars.ajaxUrl, data, function( response ) {
			// Referral logged.
		} );
	};
}

export {IconicImpactPurchase};